<template>
<div class='dialogWrapper'>
<div class="pop">
    <div class="login_boder">
    <div class="head-content" >
        <img v-if="type=='warn'" src="@/assets/warn.png">
        <img v-else src="@/assets/prompt.png">

    </div>
    <div class="content">
     <p class="pro">提示</p>
    <div class="name" v-html='errMsg'></div>
     </div>
    <div class="butt1" @click="goBack">返回</div>
  </div>
  </div>
</div>
</template>
<script>

export default {
  name: 'commonDialog',
  props: ['type', 'errMsg'],
  data() {
    return {
      dialogImgSrc: ''
    }
  },
  created() {
  },
  methods: {
    goBack() {
      this.$emit('dialogGoBack', false)
    }
  }

}
</script>
<style lang='less'>
.dialogWrapper{
  position:absolute;
.pop {
    display: block;
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
}

.login_boder {
    width: 4.24rem;
    overflow: hidden;
    border-radius: 2%;
    padding-bottom: 0.6rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -100px;
    margin-left: -2.42rem;
    background-color:#fff;
    padding-left:0.3rem;
    padding-right:0.3rem;
}
.head-content {
    text-align: center;
    margin-top: .4rem;
}

.head-content img {
    font-size: 0.20rem;
    margin-top: 0.15rem;
    width: 0.8rem;
    font-weight: 800;
}
.content {
    font-family: SimSun;
    font-size: 1.1rem;
    position: relative;
    text-align: center;
    /* padding: .3rem; */
}
.pro {
    font-size: 0.35rem;
    font-family: fantasy;
    margin:0.1rem;
}

.name {
    font-size: 0.32rem;
    color:#666;
    margin-bottom:0.3rem;
    line-height:0.5rem;

}
.butt1 {
    text-align: center;
    width: 3.6rem;
    margin: 0 auto;
    border-radius: 0.2rem;
    font-size: 0.28rem;
    height: 0.8rem;
    line-height: 0.8rem;
    color: white;
    background: #5897D0;
}
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/dialog.vue